import PropTypes from "prop-types";
import React, { useState } from "react";
import { Button, Collapse } from "reactstrap";

/**
 * Filter bar that can collapse on small screens.
 * Toggle visible on xs/sm; on md+ filters stay visible via CSS.
 */
const FilterBarCollapsible = ({ children, className = "", defaultOpen = true }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className={`filter-bar-collapsible ${className}`}>
      <div className="d-flex align-items-center gap-2 mb-2 d-md-none">
        <Button
          color="light"
          size="sm"
          onClick={() => setIsOpen(!isOpen)}
          className="d-flex align-items-center gap-1"
        >
          <i className={`mdi mdi-chevron-${isOpen ? "up" : "down"}`} />
          {isOpen ? "Hide filters" : "Show filters"}
        </Button>
      </div>
      <Collapse isOpen={isOpen} className="filter-bar-collapse-content">
        {children}
      </Collapse>
    </div>
  );
};

FilterBarCollapsible.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  defaultOpen: PropTypes.bool,
};

export default FilterBarCollapsible;
